import elderPsychiatryQuestionSet from "../faq/elderPsychiatry/allQuestions";

export const psychiatryElder = {
    'meta': {
        'title': 'Psychiatra osób starszych #cityLocativeIn# • Centrum COLLIGO',
        'description': 'Psychiatra osób starszych #cityLocativeIn#. Konsultacje psychiatryczne przeprowadzane przez lekarzy specjalistów z wieloletnim doświadczeniem klinicznym.'
    },
    'price': {
        'torun': {
            'first': 350,
            'next': 290
        }
    },
    'availability': [
        'torun'
    ],
    'url': {
        'address': '#cityIdUrl#/uslugi/psychogeriatra-psychiatra-osob-starszych/',
        'title': 'Psychiatra osób starszych #cityLocativeIn#',
        'name': 'Konsultacje psychiatryczne osób starszych #cityLocativeIn#',
        'heading': 'Psychiatria osób starszych #cityLocativeIn#',
        'fullName': 'Konsultacje psychiatryczne osób starszych'
    },
    'image': {
        'url': '/images/services/psychiatra-konsultacje-osob-starszych.webp',
        'width': 886,
        'height': 295,
        'alt': 'Psychiatra osób starszych'
    },
    'opengraph': {
        'image': {
            'url': '/images/services/psychiatra-konsultacje-osob-starszych.webp',
            'width': 886,
            'height': 295,
            'alt': 'Psychiatra osób starszych'
        }
    },
    'faq': elderPsychiatryQuestionSet
}